import React from 'react';
import {Box, Stack, Typography, Button, Divider} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {InfoBoxProps} from './types';

const {change} = translations['pt-br'].commons;

export const InfoBox = ({
	title,
	value,
	buttonLabel = change,
	onButtonClick,
	showButton = true,
}: InfoBoxProps) => (
	<Box>
		<Stack justifyContent="space-between" alignItems="center" flexDirection="row">
			<Typography variant="body2" color="text.secondary" fontWeight={600}>
				{title}
			</Typography>
			{showButton ? (
				<Button variant="text" size="medium" onClick={onButtonClick}>
					{buttonLabel}
				</Button>
			) : null}
		</Stack>
		<Typography variant="body1" color="text.primary" sx={{overflowWrap: 'break-word'}}>
			{value}
		</Typography>
		<Divider sx={{my: 1}} />
	</Box>
);
